import axios from 'axios'

export default class SmsGate {
    constructor() {
        this.element = document.getElementById('sms-gate-element')
        this.sectionSend = document.getElementById('sms-gate-section-send')
        this.sectionVerify = document.getElementById('sms-gate-section-verify')
        this.sendButton = document.getElementById('sms-gate-send-button')
        this.resendLink = document.getElementById('sms-gate-resend-link')
        this.form = document.getElementById('form-sms-gate')
        this.digits = Array.prototype.slice.call(this.element.querySelectorAll('.sms-gate__digit'))
        this.codeError = document.getElementById('sms-gate-code-error')
        this.verifyButton = document.getElementById('sms-gate-verify-button')
        this.attemptLabel = document.getElementById('sms-gate-attempt')
        this.testCode = document.getElementById('sms-gate-test-code')
        this.testCodeValue = document.getElementById('sms-gate-test-code-value')
        this.alert = document.getElementById('sms-gate-alert')
        this.sending = false
    }

    init() {
        this.digits.forEach((digit, index) => {
            digit.addEventListener('input', () => {
                // w polu zostaje wylacznie jedna cyfra - szesc osobnych pol zamiast maski 999-999
                digit.value = digit.value.replace(/\D/g, '').substring(0, 1)
                if (digit.value !== '' && index < this.digits.length - 1) {
                    this.digits[index + 1].focus()
                }
            })
            digit.addEventListener('keydown', (e) => {
                // backspace w pustym polu cofa do poprzedniego i czysci je
                if (e.key === 'Backspace' && digit.value === '' && index > 0) {
                    e.preventDefault()
                    this.digits[index - 1].value = ''
                    this.digits[index - 1].focus()
                }
            })
            digit.addEventListener('paste', (e) => {
                e.preventDefault()
                const pasted = (e.clipboardData || window.clipboardData).getData('text')
                this.fillDigits(pasted.replace(/\D/g, ''), index)
            })
        })

        this.sendButton.addEventListener('click', () => {
            this.send(this.sendButton)
        })
        this.resendLink.addEventListener('click', (e) => {
            e.preventDefault()
            // link nie ma atrybutu disabled - powtorne klikniecia blokujemy flaga
            if (this.sending) {
                return
            }
            this.send(this.verifyButton)
        })
        this.form.addEventListener('submit', (e) => {
            e.preventDefault()
            this.verify()
        })
    }

    send(button) {
        this.sending = true
        this.resendLink.classList.add('disabled')
        this.setBtnLoadingState(button, true)
        this.clearAlert()

        return axios.post(this.url('send'))
            .then((res) => {
                this.attemptLabel.textContent = res.data.attempt
                // SMS_DRIVER=fake: serwer odsyla kod, bo SMS nie zostal wyslany; pola wypelnia tester
                if (res.data.code) {
                    this.testCodeValue.textContent = res.data.code
                    this.testCode.classList.remove('d-none')
                }
                this.sectionSend.classList.add('d-none')
                this.sectionVerify.classList.remove('d-none')
                this.clearDigits()
            })
            .catch((error) => {
                this.showError(error)
            })
            .finally(() => {
                this.sending = false
                this.resendLink.classList.remove('disabled')
                this.setBtnLoadingState(button, false)
            })
    }

    verify() {
        const code = this.code()
        if (code.length < this.digits.length) {
            this.showCodeError(true)
            this.focusFirstEmpty()
            return
        }

        this.showCodeError(false)
        this.setBtnLoadingState(this.verifyButton, true)
        this.clearAlert()

        // verifyCode po stronie serwera usuwa myslniki i spacje - wysylamy szesc czystych cyfr
        return axios.post(this.url('verify'), {code: code})
            .then(() => {
                // ciasteczko ustawione - ten sam URL pokaze teraz dokument
                window.location.reload()
            })
            .catch((error) => {
                this.showError(error)
                this.setBtnLoadingState(this.verifyButton, false)
                this.clearDigits()
            })
    }

    code() {
        return this.digits.map((digit) => digit.value).join('')
    }

    fillDigits(value, startIndex) {
        let index = startIndex
        value.split('').forEach((char) => {
            if (index < this.digits.length) {
                this.digits[index].value = char
                index++
            }
        })
        this.digits[Math.min(index, this.digits.length - 1)].focus()
    }

    clearDigits() {
        this.digits.forEach((digit) => {
            digit.value = ''
        })
        this.showCodeError(false)
        this.digits[0].focus()
    }

    focusFirstEmpty() {
        const empty = this.digits.filter((digit) => digit.value === '')
        const target = empty.length ? empty[0] : this.digits[0]
        target.focus()
    }

    showCodeError(state) {
        // pola nie maja atrybutu required - komunikat .invalid-feedback odslaniamy klasa d-block
        state ? this.codeError.classList.add('d-block') : this.codeError.classList.remove('d-block')
    }

    url(action) {
        return `/documents/sms-gate/${action}/${DOCUMENT_ID}/${SIGNER_HASH}/${SIGNER}`
    }

    showError(error) {
        const message = (error.response && error.response.data && error.response.data.error)
            ? error.response.data.error
            : this.element.dataset.errorGeneric
        this.alert.innerHTML = '<div class="alert alert-danger my-3">' + message + '</div>'
    }

    clearAlert() {
        this.alert.innerHTML = ''
    }

    setBtnLoadingState(element, state) {
        let spinner = element.querySelector('.spinner-border')
        element.disabled = state
        state ? spinner.classList.remove('invisible') : spinner.classList.add('invisible')
    }
}
